import React from 'react'
import { hooks } from '@front/volcanion'

const withContainer = Component => ({ model, company, disableTarget }) => {
  const [{ record_id, model_name: parentModelName, isManagingRecord }] = hooks.useFormState()

  const enableSubmitAll = !!isManagingRecord

  const mergedProps = {
    model_name: model,
    enableSubmitAll,
    parentModelName,
    record_id,
    company,
    disableTarget
  }

  return (
    <Component {...mergedProps} />
  )
}

export default withContainer
